module.exports = __webpack_public_path__ + "img/najdispoj.1817ea03.webp";